<template>
    <layout-full-width :title="$t('logging')">
        <div class="row">
            <div class="col-4">
                <div class="card">
                    <div class="card-header">
                        {{ $t('log-settings') }}
                    </div>
                    <div class="card-body">
                        <div class="mb-2">
                            <label class="form-label" for="log-level">
                                <strong>{{ $t('application-log-level') }}</strong>
                            </label>
                            <select id="log-level" class="form-select" name="log-level">
                                <option value="">{{ $t('log-levels.critical') }}</option>
                                <option value="">{{ $t('log-levels.error') }}</option>
                                <option value="">{{ $t('log-levels.warning') }}</option>
                                <option value="">{{ $t('log-levels.info') }}</option>
                                <option value="">{{ $t('log-levels.debug') }}</option>
                            </select>
                        </div>
                        <div class="mb-2">
                            <label class="form-label" for="log-file">
                                <strong>{{ $t('log-file') }}</strong>
                            </label>
                            <select id="log-file" class="form-select" name="log-file">
                                <option value="">{{ $t('select-log-file') }}</option>
                            </select>
                        </div>
                        <button class="btn btn-primary float-end">{{ $t('actions.save') }}</button>
                    </div>
                </div>
            </div>
        </div>

    </layout-full-width>
</template>

<script>
import LayoutFullWidth from "@/layouts/LayoutFullWidth";

export default {
    name: "PageLogging",
    components: {LayoutFullWidth},
    methods: {}
}
</script>

<style lang="scss" scoped></style>